module.exports = __webpack_public_path__ + "img/Haut.db9d43a8.png";